// @flow
import TetherToggle from './tether-toggle';

export default TetherToggle;
